import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';
import { media } from 'settings/style';

export const RecurringSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RecurringControlsRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  width: 100%;

  .recurring-switch-wrap,
  .recurring-pattern-wrap {
    display: flex;
    align-items: center;
  }

  .recurring-switch-wrap {
    flex-shrink: 0;
  }

  .recurring-pattern-wrap {
    flex: 1;
    min-width: 0;

    .ant-form-item {
      margin-bottom: 0;
      width: 100%;
    }

    .ant-select {
      width: 100%;
    }
  }

  .ant-switch {
    height: 32px;
    line-height: 32px;
  }

  .ant-switch-handle {
    top: 5px;
  }

  ${media.md`
    flex-wrap: nowrap;
    gap: 8px;

    .recurring-switch-wrap,
    .recurring-pattern-wrap {
      flex: 1 1 0;
      min-width: 0;
      max-width: 50%;
    }

    .recurring-switch-wrap {
      justify-content: flex-start;
    }
  `}
`;

export const RecurringDayInputRow = styled.div`
  width: 100%;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

/** Mobile overflow fix for RangePicker time columns only (popup). */
export const EventDateTimeRangePickerStyles = createGlobalStyle`
  .event-datetime-range-popup.ant-picker-dropdown {
    ${media.md`
      max-width: calc(100vw - 24px);

      .ant-picker-panel-container {
        max-width: 100%;
      }

      .ant-picker-datetime-panel {
        flex-direction: column !important;
      }

      .ant-picker-time-panel {
        width: 100%;
        max-width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }

      .ant-picker-time-panel-column {
        max-height: 180px;
      }
    `}
  }
`;
